<template>
  <div>
    <popover-text
      :style="[popoverStyle]"
      :line="1"
      :text="getText"
      :colType="colType"
      :tableData="tableData"
      :scope="scope"
      :disabled="disabled"
      :subText="getSubtext"
    >
    </popover-text>
  </div>
</template>

<script>
import popoverText from '@/components/tools/popoverText.vue';
export default {
  props: ['scope', 'tableData'],
  data() {
    return {};
  },
  computed: {
    popoverStyle() {
      return this.tableData.popoverStyle || {};
    },
    disabled() {
      if (this.tableData.setdisabled) {
        return this.tableData.setdisabled(
          this.scope.row[this.tableData.bind],
          this.scope.row
        );
      }
      return this.tableData.disabled || false;
    },
    colType() {
      return this.tableData.colType || '';
    },
    getText() {
      if (this.tableData.formatter) {
        return this.tableData.formatter(
          this.scope.row[this.tableData.bind],
          this.scope.row
        );
      }
      if (this.tableData.title) {
        return `${this.tableData.title}：${this.scope.row[
          this.tableData.bind
        ] || '-'}`;
      }
      return this.scope.row[this.tableData.bind] || '-';
    },
    getSubtext() {
      let { row } = this.scope;
      if (this.tableData.subtext) {
        return this.tableData.subtext(row, this.tableData);
      }
      return this.getText;
    }
  },
  methods: {},
  components: {
    popoverText
  }
};
</script>

<style></style>
